import { AccessPolicyValue } from '../rbac/types';

/**
 * Stored policy data structure (from backend)
 * This is what comes back from the API in policy.Data
 */
export interface DockerRegistryPolicyData {
  RegistryAccessPolicies: Record<
    // registry ID
    string,
    // user and team ids with access to the registry
    {
      UserAccessPolicies: Record<string, AccessPolicyValue>;
      TeamAccessPolicies: Record<string, AccessPolicyValue>;
    }
  >;
}

/**
 * API payload for Docker Registry Policy
 * Uses PascalCase to match backend expectations
 */
export interface DockerRegistryPolicyPayload {
  RegistryAccessPolicies: Record<
    // registry ID
    string,
    // user and team ids with access to the registry
    {
      UserAccessPolicies: Record<string, AccessPolicyValue>;
      TeamAccessPolicies: Record<string, AccessPolicyValue>;
    }
  >;
}

/**
 * Form data for Docker Registry Policy
 * Represents a row per registry with lists of user/team IDs
 */
export interface DockerRegistryFormData {
  accessRows: Array<{
    registryId: number;
    userIds: number[];
    teamIds: number[];
  }>;
}

/**
 * Default initial values for Docker Registry Policy (create mode)
 */
export const DOCKER_REGISTRY_INITIAL_VALUES: DockerRegistryFormData = {
  accessRows: [],
};
